import { useEffect } from 'react';
import { toast } from 'react-toastify';
import {
  CompletedChart,
  InProgressChart,
  RejectedChart,
  useOrchestratorList,
} from '@domains/orchestrator-pricing-committee';
import { useSelector } from 'react-redux';
import { getSelectedStatus } from '@domains/orchestrator-pricing-committee/store/slices/domainOrchestratorPricingCommittee.slice';
import { OrchestratorPricingCommitteeLayout } from '@pages/OrchestratorPricingCommitteePage/shared/OrchestratorPricingCommitteeLayout/OrchestratorPricingCommitteeLayout';

export const AnalyticsOPC = () => {
  const selectedStatus = useSelector(getSelectedStatus);
  const { orchestrators } = useOrchestratorList();
  const { isFetching } = orchestrators;

  useEffect(() => {
    if (isFetching) {
      toast.loading('Cargando analytics...', {
        toastId: 'loading-analytics-opc',
        position: 'bottom-right',
        closeButton: true,
      });
    } else {
      toast.dismiss('loading-analytics-opc');
    }
  }, [isFetching]);

  useEffect(() => {
    return () => {
      toast.dismiss('loading-analytics-opc');
    };
  }, []);

  const renderChart = () => {
    if (selectedStatus === 'COMPLETED') return <CompletedChart />;
    if (selectedStatus === 'IN_PROGRESS') return <InProgressChart />;
    return <RejectedChart />;
  };

  return (
    <OrchestratorPricingCommitteeLayout title="Analytics OPC">
      {renderChart()}
    </OrchestratorPricingCommitteeLayout>
  );
};
